import { jsx } from "react/jsx-runtime";
import ZHLRateCards from "@zillow/zhl-rate-card";
import "react";
const RateCardsBlock = {
  Component: ({
    attrs,
    blockData
  }) => {
    return /* @__PURE__ */ jsx(ZHLRateCards, { data: blockData, ...attrs });
  },
  metadata: {
    name: "zhl/zhl-rate-cards",
    title: "ZHL Rate Cards",
    description: "Set of rate cards for ZHL",
    icon: "editor-table",
    category: "more",
    keywords: ["zhl", "loan", "rate", "cards"],
    attributes: {
      layout: {
        type: "string",
        control: "select",
        default: "single",
        choices: [{
          label: "Single",
          value: "single"
        }, {
          label: "Tabbed",
          value: "tabbed"
        }, {
          label: "Merged",
          value: "merged"
        }],
        description: "Layout for the rate cards",
        label: "Layout"
      },
      whiteCardButtonLink: {
        type: "string",
        control: "text",
        default: "https://www.zillow.com/",
        description: "White cards button link",
        label: "White Card Button Link"
      },
      whiteCardModalLinkText: {
        type: "string",
        control: "text",
        default: "See sample loan terms",
        description: "Text for the white card modal button",
        label: "White Card Modal Button"
      },
      whiteCardsButtonText: {
        type: "string",
        control: "text",
        default: "Get Pre-Approved",
        description: "Text for the white cards button",
        label: "White Cards Button Text"
      },
      showDesc: {
        type: "boolean",
        control: "boolean",
        default: false,
        description: "Display card description",
        label: "Show Description"
      },
      modalSummary: {
        type: "string",
        control: "text",
        default: "",
        description: "Summary for white cards modal",
        label: "Custom modal summary"
      },
      modalFHAInformation: {
        type: "string",
        control: "text",
        default: "",
        description: "FHA information for related white cards modal",
        label: "Custom FHA information"
      },
      modalButtonText: {
        type: "string",
        control: "text",
        default: "Get Pre-Approved",
        description: "Text for the modal button",
        label: "White Cards Button Text"
      },
      modalButtonLink: {
        type: "string",
        control: "text",
        default: "https://www.zillow.com/",
        description: "Modal button link",
        label: "Modal Button Link"
      },
      blueCardButtonText: {
        type: "string",
        control: "text",
        default: "Get your personalized rate",
        description: "Text for the blue card button",
        label: "Blue Card Button Text"
      },
      blueCardLink: {
        type: "string",
        control: "text",
        default: "https://www.zillow.com/",
        description: "Link for the blue card button",
        label: "Blue Card Link"
      },
      blueCardHeader: {
        type: "string",
        control: "text",
        default: "Get a personalized rate",
        description: "Text for the blue card header",
        label: "Blue Card Header"
      },
      blueCardText: {
        type: "string",
        control: "text",
        default: "Mortgage rates aren't one size fits all. We can give you an estimate based on your unique details.",
        description: "Text for the blue card",
        label: "Blue Card Text"
      },
      blueCardImage: {
        type: "string",
        control: "text",
        default: "https://delivery.digitalassets.zillowgroup.com/api/public/content/SZ_STUDIO_B2CPA_LA_Edeani_2024_Colonial_Ext_Porch_0500_rgb_768x360?v=d326909e",
        description: "Image link to be displayed in custom card",
        label: "Blue Card Image URL"
      },
      enable30yFixed: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 30 year fixed rate card",
        label: "Enable 30 year fixed rate card"
      },
      enable30yFHA: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 30 year FHA rate card",
        label: "Enable 30 year FHA rate card"
      },
      enable30yVA: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 30 year VA rate card",
        label: "Enable 30 year VA rate card"
      },
      enable20yFixed: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 20 year fixed rate card",
        label: "Enable 20 year fixed rate card"
      },
      enable15yFixed: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 15 year fixed rate card",
        label: "Enable 15 year fixed rate card"
      },
      enable25yFHA: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 25 year FHA rate card",
        label: "Enable 25 year FHA rate card"
      },
      enable20yFHA: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 20 year FHA rate card",
        label: "Enable 20 year FHA rate card"
      },
      enable10yFixed: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 10 year fixed rate card",
        label: "Enable 10 year fixed rate card"
      },
      enable30yJumbo: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 30 year jumbo rate card",
        label: "Enable 30 year jumbo rate card"
      },
      enable7ARM: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable 7 year ARM rate card",
        label: "Enable 7 year ARM rate card"
      },
      enableBlueCard: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Enable blue card",
        label: "Enable blue card"
      },
      showLastUpdated: {
        type: "boolean",
        control: "boolean",
        default: true,
        description: "Show last updated date label",
        label: "Show last updated date label"
      },
      state: {
        type: "string",
        control: "text",
        default: "CA",
        description: "State to fetch rates for, use two letter abbreviation",
        label: "State"
      }
    }
  },
  getBlockData: async ({
    attrs
  }) => {
    const state = (attrs == null ? void 0 : attrs.state) || "CA";
    const apiUrl = process.env.ZHL_RATES_API_URL + `/zhlRatePage/states/${state}`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET"
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }
};
export {
  RateCardsBlock as default
};
